import { download, generateCsv, mkConfig } from "export-to-csv"
import { useDateTime } from "../../../../../localization/useDateTime"
import { SupportSMS } from "../smsTypes"
import { MRT_Row } from "material-react-table"

export const useExportSMS = (chosenStartDate: string, chosenEndDate: string) => {
    const dateTimeFactory = useDateTime()

    const formattedStartDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(chosenStartDate))
    const formattedEndDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(chosenEndDate))

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ".",
        useBom: true,
        useKeysAsHeaders: true,
        filename: `SMS-${formattedStartDate}_${formattedEndDate}`,
    })

    const handleExportRows = (rows?: MRT_Row<SupportSMS>[]) => {
        if (!rows) return

        const rowData = rows.map((row) => row.original)

        const exportRows = rowData.map((sms) => ({
            Receiver: sms.receiver.phoneNumber,
            Created: dateTimeFactory.formatDate(dateTimeFactory.fromApi(sms.history.created)),
            Sent: dateTimeFactory.formatDate(dateTimeFactory.fromApi(sms.sentTime)),
            Status: sms.status.text,
        }))

        const csv = generateCsv(csvOptions)(exportRows)
        download(csvOptions)(csv)
    }

    return { handleExportRows }
}
